import { IconButton } from 'components/IconButton/IconButton';
import { ArrowBack } from '@mui/icons-material';
import React from 'react';
import { IconButtonProps } from '@mui/material';

export const BackButton = ({ 'aria-label': ariaLabel = 'Go back', ...rest }: IconButtonProps) => (
  <IconButton {...rest} aria-label={ariaLabel}>
    <ArrowBack fontSize="medium" />
  </IconButton>
);
